import React from "react";
import Button from '@mui/material/Button';
import { ValidateFinancialDocInput } from "./ValidateFinancialDocInput";
const btnsArray = [
  { operation: "Display" },
  { operation: "Change" },
  {
    operation: "Create",
    navPath: (navigate) => navigate(`/FinancialDoc/Create`),
  },
];

export default function OverviewButtons({
  financialDoc,
  navigate,
  _getFinancialDocExists,
  _createErrorMessage,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => {
              if (operation === "Create") {
                navPath(navigate);
                return;
              }

              let validationFinancialDocResult = ValidateFinancialDocInput(
                financialDoc,
                _createErrorMessage
              );

              if (!validationFinancialDocResult) {
                return;
              }

              _getFinancialDocExists(
                { data: { Id: financialDoc } },
                ({ data: isExist }) => {
                  if (!isExist) {
                    _createErrorMessage("73");
                    return;
                  }
                  const navigationUrl = `/FinancialDoc/${financialDoc}/${operation}`;
                  navigate(navigationUrl);
                }
              );
            }}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
